// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "../helpers/debug";
import type { PaymentMethod } from "../types";

const getPaymentMethods = (
  listingId: string
): ((apiInstance: AxiosInstance) => AxiosPromise<PaymentMethod>) => (
  apiInstance
) => {
  debug("getPaymentMethods", listingId);

  return apiInstance.get("/v4/users/payment-methods", {
    params: {
      listing_id: listingId,
      include_corporate: 1
    }
  });
};

export default getPaymentMethods;
